import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { BaseTabs } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import CollectionsBootstrap from 'modules/posts/lib/PostsCollectionsBootstrap'

const PostsRootPage = () => {
  const { navigation } = useNavigation()
  return (
    <Box flexGrow>
      <CollectionsBootstrap>
        <BaseTabs
          tabs={[
            {
              id: 'communities',
              index: true,
              label: i18n.t('posts.communities.tabs.communities'),
              href: navigation.communities.fullPath(),
            },
            {
              id: 'posts',
              label: i18n.t('posts.communities.tabs.posts'),
              href: navigation.communities.posts.fullPath(),
            },
          ]}
        />
        <Outlet />
      </CollectionsBootstrap>
    </Box>
  )
}

export default PostsRootPage
